import { render, staticRenderFns } from "./MysteryBox.vue?vue&type=template&id=651eb59c&scoped=true"
import script from "./MysteryBox.vue?vue&type=script&lang=js"
export * from "./MysteryBox.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=651eb59c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651eb59c",
  null
  
)

export default component.exports